import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import Field from '../../Wizard/Field/Field';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import { FormGroup, Switch, Typography} from '@material-ui/core';

function CreateCustomerModal(this: any, props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const[customerType, setCustomerType] = useState("none");

    const[newApArNo, setNewApArNo] = useState("");

    const[newOrganizationName, setNewOrganizationName] = useState("");
    const[newCompanyRegistrationId, setNewCompanyRegistrationId] = useState("");
    const[newShortName, setNewShortName] = useState("");
    const[newCountryCodeOrg, setNewCountryCodeOrg] = useState("");

    const[newAddressType, setNewAddressType] = useState("");
    const[newFirstName, setNewFirstName] = useState("");
    const[newLastName, setNewLastName] = useState("");
    const[newContactPosition, setNewContactPosition] = useState("");
    const[newAddress, setNewAddress] = useState("");
    const[newCity, setNewCity] = useState("");
    const[newProvince, setNewProvince] = useState("");
    const[newPostcode, setNewPostcode] = useState("");
    const[newCountryCode, setNewCountryCode] = useState("");
    const[newEmail, setNewEmail] = useState("");
    const[newPhone, setNewPhone] = useState("");

    const[newRelAttrId, setNewRelAttrId] = useState("");
    const[checkIfPrivatePerson, setCheckIfPrivatePerson] = useState(false); 

    // const updateNewAddressType = event => setNewAddressType(event.target.value);

    function clearForm(){
        setCustomerType("none");

        setNewApArNo("");
        setNewOrganizationName("");
        setNewCompanyRegistrationId("");
        setNewShortName("");
        setNewCountryCodeOrg("");

        setNewAddressType("");
        setNewFirstName("");
        setNewLastName("");
        setNewContactPosition("");
        setNewAddress("");
        setNewCity("");
        setNewProvince("");
        setNewPostcode("");
        setNewCountryCode("");
        setNewEmail("");
        setNewPhone("");

        setNewRelAttrId("");
    }

    function handleCloseCustomerModal(){
        clearForm();
        if(props.onCancel != undefined) props.onCancel();
        if(props.onHide != undefined) props.onHide();
    }

    function handleCreateCustomer() {
        let isOnlyNumPattern = new RegExp(/^[[0-9]*$/);

        if(newApArNo == "" && !checkIfPrivatePerson) {notifyWarning(t("customers.toast.empty_apArNo")); return undefined; }
        if(!isOnlyNumPattern.test(newApArNo)) {notifyWarning(t("customers.toast.invalid_apArNo")); return undefined; }
        if(newOrganizationName == "" && !checkIfPrivatePerson) {notifyWarning(t("customers.toast.empty_organization_name")); return undefined; }
        if(newCompanyRegistrationId !== undefined && newCompanyRegistrationId !== "" && !checkIfPrivatePerson) {
            if (!isOnlyNumPattern.test(newCompanyRegistrationId)) {
                notifyWarning(t("customers.toast.invalid_company_registration_id"));
                return undefined;
            }
        }
        if(newCompanyRegistrationId == "" && !checkIfPrivatePerson) {notifyWarning(t("customers.toast.empty_company_registration_id")); return undefined; }
        // if(newShortName == "" && !checkIfPrivatePerson) {notifyWarning(t("customers.toast.empty_short_name")); return undefined; }
        // if(newCountryCodeOrg == "" && !checkIfPrivatePerson) {notifyWarning(t("customers.toast.empty_country_code_org")); return undefined; }
        //if(newAddressType == "1") {notifyWarning(t("customers.toast.empty_address_type")); return undefined; }
        if(newFirstName == "") {notifyWarning(t("customers.toast.empty_first_name")); return undefined; }
        if(newLastName == "") {notifyWarning(t("customers.toast.empty_last_name")); return undefined; }
        if(newPhone !== undefined && newPhone !== "") {
            if (!isOnlyNumPattern.test(newPhone)) {
                notifyWarning(t("customers.toast.invalid_phone"));
                return undefined;
            }
        }
        if(newPhone == "") {notifyWarning(t("customers.toast.empty_phone")); return undefined; }
        if(newEmail !== "undefined") {
            let pattern = new RegExp(/^$|^([\w\.\-]+)@([\w\-]+)((\.(\w){2,})+)$/);
            if (!pattern.test(newEmail)) {
                notifyWarning(t("customers.toast.invalid_email"));
                return undefined;
            }
        }
        if(newEmail == "") {notifyWarning(t("customers.toast.empty_email")); return undefined; }
        if(newContactPosition == "" && !checkIfPrivatePerson) {notifyWarning(t("customers.toast.empty_contact_position")); return undefined; }
        if(newAddress == "") {notifyWarning(t("customers.toast.empty_address")); return undefined; }
        if(newRelAttrId == "" && !checkIfPrivatePerson) {notifyWarning(t("customers.toast.empty_relAttrId")); return undefined; }
        //if(newCity == "") {notifyWarning(t("customers.toast.empty_city")); return undefined; }
        //if(newProvince == "") {notifyWarning(t("customers.toast.empty_province")); return undefined; }
        //if(newPostcode == "") {notifyWarning(t("customers.toast.empty_post_code")); return undefined; }
        //if(newCountryCode == "" && !checkIfPrivatePerson) {notifyWarning(t("customers.toast.empty_country_code")); return undefined; }
      

        axios.post(
            "/api/customers",
            {
                apArNo: newApArNo,
            
                organizationName: newOrganizationName,
                companyRegistrationId: newCompanyRegistrationId,
                shortName: newShortName,
                countryCodeOrg: newCountryCodeOrg,
            
                addressType: newAddressType,
                firstname: newFirstName,
                lastname: newLastName,
                contactPosition: newContactPosition,
                address: newAddress,
                city: newCity, 
                province: newProvince, 
                postcode: newPostcode,
                countryCode: newCountryCode,
                email: newEmail,
                phone: newPhone,
            
                relAttrId: newRelAttrId,
            },
            {
                headers: {'x-access-token': auth.user["token"]}
            }
        ).then(res => {
            if (props.onSaveNew != undefined) props.onSaveNew(res.data);
            notifySuccess(t("customers.toast.customer_created"));
            clearForm();
        }).catch(err => {
            console.log(err.response.status);
            if(err.response.status == 409) notifyWarning(t("customers.toast.customer_duplicated"));
        });
    }

    return (
        
        <Modal show={props.show} onHide={handleCloseCustomerModal} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {(t("customers.new"))}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {customerType == "none" ?
                    <div>
                        <p
                            style={{
                                textAlign: "center",
                                marginTop: "20px"
                            }}
                        >{t("customers.createmodal.selecttype")}</p>
                        <div className="row" style={{
                            marginTop: "60px",
                            marginBottom: "60px"
                        }}>
                            <div className="col-md-6" style={{ textAlign: "center" }}>
                                <Button
                                    onClick={evt => {setCustomerType("company"); setCheckIfPrivatePerson(false);}}
                                    style={{
                                        height: "70px",
                                        fontWeight: 600,
                                        minWidth: "200px",
                                        fontSize: "18px"
                                    }}
                                >{(t("customers.createmodal.types.company"))}</Button>
                            </div>
                            <div className="col-md-6" style={{ textAlign: "center" }}>
                                <Button onClick={evt => {setCustomerType("private"); setCheckIfPrivatePerson(true);}}
                                    style={{
                                        height: "70px",
                                        fontWeight: 600,
                                        minWidth: "200px",
                                        fontSize: "18px"
                                    }}
                                >{(t("customers.createmodal.types.private"))}</Button>
                            </div>
                        </div>
                    </div>
                : null }
                {customerType == "private" ?
                    <div> 
                        <p>{(t("customers.privatePerson"))}</p>
                        <Field
                            type="input"
                            title={(t("customers.apArNo"))}
                            value={newApArNo}
                            onChange={value => setNewApArNo(value)}
                        ></Field>
                        <div className="row">
                            <div className="col col-sm-6">
                                <Field
                                    type="input"
                                    title={(t("customers.firstname") + '*')}
                                    value={newFirstName}
                                    onChange= {value => setNewFirstName(value)}
                                ></Field>
                            </div>
                            <div className="col col-sm-6">
                                <Field
                                    type="input"
                                    title={(t("customers.lastname") + '*')}
                                    value={newLastName}
                                    onChange= {value => setNewLastName(value)}
                                ></Field>
                            </div>
                            <div className="col col-sm-12">
                                <Field
                                    type="input"
                                    title={(t("customers.phone") + '*')}
                                    value={newPhone}
                                    onChange= {value => setNewPhone(value)}
                                ></Field>
                            </div>
                        </div>
                        <Field
                            type="input"
                            title={(t("customers.email") + '*')}
                            value={newEmail}
                            onChange= {value => setNewEmail(value)}
                        ></Field>
                        <Field
                            type="input"
                            title={(t("customers.address") + '*')}
                            value={newAddress}
                            onChange= {value => setNewAddress(value)}
                        ></Field>
                        <div className="row">
                            <div className="col col-sm-6">
                                <Field
                                    type="input"
                                    title={(t("customers.city"))}
                                    value={newCity}
                                    onChange= {value => setNewCity(value)}
                                ></Field>
                            </div>
                            <div className="col col-sm-6">
                                <Field
                                    type="input"
                                    title={(t("customers.postCode"))}
                                    value={newPostcode}
                                    onChange= {value => setNewPostcode(value)}
                                ></Field>
                            </div>
                        </div>

                    </div> 
                : null }
                {customerType == "company" ?
                    <div> 
                        <p>{(t("customers.company"))}</p>
                        <Field
                            type="input"
                            title={(t("customers.apArNo"))}
                            value={newApArNo}
                            onChange={value => setNewApArNo(value)}
                        ></Field>
                        <Field
                            type="input"
                            title={(t("customers.organization") + '*')}
                            value={newOrganizationName}
                            onChange= {value => setNewOrganizationName(value)}
                        ></Field>
                        <Field
                            type="input"
                            title={(t("customers.companyRegistrationId") + '*')}
                            value={newCompanyRegistrationId}
                            onChange= {value => setNewCompanyRegistrationId(value)}
                        ></Field>
                        <Field
                            type="input"
                            title={(t("customers.address") + '*')}
                            value={newAddress}
                            onChange= {value => setNewAddress(value)}
                        ></Field>
                        <div className="row">
                            <div className="col col-sm-6">
                                <Field
                                    type="input"
                                    title={(t("customers.city"))}
                                    value={newCity}
                                    onChange= {value => setNewCity(value)}
                                ></Field>
                            </div>
                            <div className="col col-sm-6">
                                <Field
                                    type="input"
                                    title={(t("customers.postCode"))}
                                    value={newPostcode}
                                    onChange= {value => setNewPostcode(value)}
                                ></Field>
                            </div>
                        </div>
                        <Field
                            type="input"
                            title={(t("customers.relAttrId") + '*')}
                            value={newRelAttrId}
                            onChange= {value => setNewRelAttrId(value)}
                        ></Field>
                        <hr />
                        <p>{(t("customers.privatePerson"))}</p>
                        <div className="row">
                            <div className="col col-sm-6">
                                <Field
                                    type="input"
                                    title={(t("customers.firstname") + '*')}
                                    value={newFirstName}
                                    onChange= {value => setNewFirstName(value)}
                                ></Field>
                            </div>
                            <div className="col col-sm-6">
                                <Field
                                    type="input"
                                    title={(t("customers.lastname") + '*')}
                                    value={newLastName}
                                    onChange= {value => setNewLastName(value)}
                                ></Field>
                            </div>
                            <div className="col col-sm-12">
                                <Field
                                    type="input"
                                    title={(t("customers.phone") + '*')}
                                    value={newPhone}
                                    onChange= {value => setNewPhone(value)}
                                ></Field>
                            </div>
                        </div>
                        <Field
                            type="input"
                            title={(t("customers.email") + '*')}
                            value={newEmail}
                            onChange= {value => setNewEmail(value)}
                        ></Field>

                        <Field
                            type="input"
                            title={(t("customers.contactPosition") + '*')}
                            value={newContactPosition}
                            onChange= {value => setNewContactPosition(value)}
                        ></Field>
                    </div>
                : null }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleCloseCustomerModal}>{(t("customers.cancel"))}</Button>
                <Button onClick={handleCreateCustomer}>{(t("customers.save"))}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CreateCustomerModal;
